/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";
import { enumType } from "@pagopa/ts-commons/lib/types";

export enum TypeEnum {
  "CARDS" = "CARDS"
}

/**
 * Card verify request details
 */

// required attributes
const WalletVerifyRequestCardDetailsR = t.interface({});

// optional attributes
const WalletVerifyRequestCardDetailsO = t.partial({
  type: enumType<TypeEnum>(TypeEnum, "type"),

  iframeUrl: t.string
});

export const WalletVerifyRequestCardDetails = t.intersection(
  [WalletVerifyRequestCardDetailsR, WalletVerifyRequestCardDetailsO],
  "WalletVerifyRequestCardDetails"
);

export type WalletVerifyRequestCardDetails = t.TypeOf<
  typeof WalletVerifyRequestCardDetails
>;
